<template>
  <transition name="fade-in">
    <div v-if="modal_open" class="fixed top-0 left-0 right-0 bottom-0 bg-dim z-50 flex flex-col justify-around p-5">
      <div
        class="bg-white rounded-lg w-full mx-auto max-h-full overflow-y-auto"
        :style="{ maxWidth: maxWidth + 'px' }"
        @click.stop
      >
        <modal-window
          v-if="isForm && isEdited && isClosing"
          :is-form="false"
          :modal_open="true"
          :is-closable="false"
          title="There are unsaved changes in this form"
          @close="$emit('close')"
        >
          <div class="text-right mt-4 xs:mt-8 flex flex-col 2xs:block">
            <button class="btn btn-lg 2xs:mr-1 mb-1 2xs:mb-0" @click="isClosing = false">Go Back</button>
            <button class="btn btn-action btn-lg" @click="$emit('close')">Discard</button>
          </div>
        </modal-window>
        <div
          class="sticky top-0 bg-white flex border-b justify-between px-3 xs:px-10 py-3 flex-wrap-reverse z-40 empty:hidden"
        >
          <div v-if="title" class="font-medium text-xl">
            {{ title }}
          </div>
          <div v-if="isClosable" class="flex ml-auto">
            <div
              class="pl-6 flex flex-col text-xl justify-around text-gray-600 cursor-pointer"
              @click="!isEdited || !isForm ? $emit('close') : (isClosing = true)"
            >
              <i class="fal fa-times" />
            </div>
          </div>
        </div>
        <div ref="modal" class="p-3 xs:p-10">
          <slot />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    maxWidth: {
      default: 800
    },
    modal_open: {
      default: false
    },
    isClosable: {
      default: true
    },
    isForm: {
      default: true
    },
    title: String,
    loading: Boolean
  },
  data() {
    return {
      isEdited: false,
      isClosing: false,
      isUpdated: false
    }
  },
  watch: {
    modal_open: {
      async handler(to) {
        if (to) {
          this.$nextTick(() => {
            const inputElements = this.$refs.modal.querySelectorAll('input, textarea')
            for (let i = 0; i < inputElements.length; i++) {
              inputElements[i].addEventListener('input', this.handleInputChange)
            }

            const selectElements = this.$refs.modal.querySelectorAll('select')
            for (let i = 0; i < selectElements.length; i++) {
              selectElements[i].addEventListener('change', this.handleInputChange)
            }

            const buttonElements = this.$refs.modal.querySelectorAll('button')
            for (let i = 0; i < buttonElements.length; i++) {
              buttonElements[i].addEventListener('click', this.handleInputChange)
            }
          })
        }
      },
      immediate: true
    }
  },
  beforeUnmount() {
    const inputElements = this.$refs.modal?.querySelectorAll('input, textarea, select') || []
    for (let i = 0; i < inputElements.length; i++) {
      inputElements[i].removeEventListener('input', this.handleInputChange)
    }
    const buttonElements = this.$refs.modal?.querySelectorAll('button') || []
    for (let i = 0; i < buttonElements.length; i++) {
      buttonElements[i].removeEventListener('click', this.handleInputChange)
    }
  },
  methods: {
    handleInputChange() {
      this.isEdited = true
    }
  }
}
</script>
